export function DeleteIcon({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="Delete"
    >
      <path
        d="M6.5808 1.5C6.25424 1.5 5.9596 1.70436 5.8442 2.01212L5.44643 3.07576H3.08929C2.76272 3.07576 2.5 3.3392 2.5 3.66667C2.5 3.99413 2.76272 4.25758 3.08929 4.25758H12.9107C13.2373 4.25758 13.5 3.99413 13.5 3.66667C13.5 3.3392 13.2373 3.07576 12.9107 3.07576H10.5536L10.1558 2.01212C10.0404 1.70436 9.74821 1.5 9.4192 1.5H6.5808ZM3.28571 5.43939V12.9242C3.28571 13.7934 3.9904 14.5 4.85714 14.5H11.1429C12.0096 14.5 12.7143 13.7934 12.7143 12.9242V5.43939H11.5357V12.9242C11.5357 13.1409 11.3589 13.3182 11.1429 13.3182H4.85714C4.64107 13.3182 4.46429 13.1409 4.46429 12.9242V5.43939H3.28571ZM7.21429 7.21212C7.21429 6.88466 6.95156 6.62121 6.625 6.62121C6.29844 6.62121 6.03571 6.88466 6.03571 7.21212V11.5455C6.03571 11.8729 6.29844 12.1364 6.625 12.1364C6.95156 12.1364 7.21429 11.8729 7.21429 11.5455V7.21212ZM9.96429 7.21212C9.96429 6.88466 9.70156 6.62121 9.375 6.62121C9.04844 6.62121 8.78571 6.88466 8.78571 7.21212V11.5455C8.78571 11.8729 9.04844 12.1364 9.375 12.1364C9.70156 12.1364 9.96429 11.8729 9.96429 11.5455V7.21212Z"
        fill="currentColor"
      />
    </svg>
  );
}
